import type { FSSAgentPayload } from "@mirage/mosaics/ConversationAssistant/containers/ConversationAssistantPageContent/FSS/useFSSOpsHandling";
import type {
  ComposeParams,
  SourceContent,
} from "@mirage/service-dbx-api/service/grpc/context_engine_apiv2/gen/assist_compose_pb";
import { useMemo } from "react";

interface AgentPayload {
  fss_ops?: FSSAgentPayload;

  // for legacy reasons, the compose params are sent on the top level
  markdownContent: string;
  mustGenerateDraft: boolean;
  voiceId: string;
  voiceSources: SourceContent[];
  voiceModificationHistory: string[];
  templateId: string;
  templateSources: SourceContent[];
  templateModificationHistory: string[];
  customVoiceSamples: string[];
  customTemplateContent: string;
}

/**
 * This hook is used to combine different agent payloads into a single object that will be sent
 * to the conversational API.
 * @param composeParams - The compose params for the "Write" (aka Compose) agent.
 * @param fssOpsAgentPayload - The fss ops agent payload for the FSS Ops agent.
 * @returns The combined agent payload.
 */
export function useAgentPayload(
  composeParams: ComposeParams,
  fssOpsAgentPayload: FSSAgentPayload | undefined,
) {
  return useMemo(() => {
    const agentPayload: AgentPayload = {
      ...composeParams,
    };
    if (fssOpsAgentPayload) {
      agentPayload.fss_ops = fssOpsAgentPayload;
    }
    return agentPayload;
  }, [composeParams, fssOpsAgentPayload]);
}
